import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import TextField from "material-ui/TextField";
import { FormControl, FormLabel } from "material-ui/Form";
import Select from "material-ui/Select";
import { MenuItem } from "material-ui/Menu";
import Button from "material-ui/Button";
import { Link } from 'react-router-dom';
import { validateResetPassword } from "../../utils/validator";
import { SECURITY_QUESTIONS } from "../../constants/Constants";
import moment from "moment";

const styles = (theme) => ({
  lastUpdate: {
    textAlign: "right",
    fontSize: "11px",
  },

  formLabel: {
    position: "absolute",
    top: 0,
    left: 0,
  },

  formControl: {
    width: "100%",
    color: "#181819",
  },

  select: {
    textAlign: "left",
    fontSize: "13px",
    fontWeight: "regular",
    minWidth: "200px",
    backgroundColor: theme.palette.common.white,
    borderBottom: "1px solid #D8DBDF",
    padding: "8px 12px",
    marginTop: "3px",
  },

  buttonContainer: {
    display: "inline-flex",
    width: "100%",
    justifyContent: "space-evenly",
    margin: "40px 0",
  },

  button: {
    color: "#FFFFFF",
    backgroundColor: "#1A65FF",
    fontSize: "15px",
    fontWeight: 400,
    "&:hover": {
      backgroundColor: "#1A65FF",
      opacity: 0.6,
    },
  },
});

class ResetPasswordComponent extends React.Component {
  state = {
    password_old: "",
    password: "",
    confirm_password: "",
    security_question: SECURITY_QUESTIONS[0],
    security_answer: "",
    error: {},
  };

  componentDidMount() {
    if (this.props.addKeyDownListener) {
      document.addEventListener("keydown", this.handleKeyDown, false);
    }
  }

  componentWillUnmount() {
    if (this.props.addKeyDownListener) {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.error !== nextProps.error &&
      nextProps.error !== null &&
      typeof nextProps.error === "object" &&
      Object.keys(nextProps.error).length > 0
    ) {
      this.setState({
        error: {
          ...this.state.error,
          ...nextProps.error,
        },
      });
    }
  }

  handleChange = (property) => (event) => {
    let value = event.target.value;
    this.setState({
      [property]: value,
    });
  };

  handleSubmit = () => {
    const { showPassword, showSecurityQuestion, isChildEdit, user } = this.props;
    let { error, password_old, password, security_question, security_answer } =
      this.state;

    error = this.validateForm();

    if (Object.keys(error).length === 0) {
      if (!isChildEdit) {
        if (showPassword && showSecurityQuestion) {
          this.props.postUsersUpdatePassword({
            password_old: password_old,
            password: password,
            security_question: security_question,
            security_answer: security_answer,
          });
        } else if (showPassword) {
          this.props.postUsersUpdatePassword({
            password_old: password_old,
            password: password,
          });
        } else if (showSecurityQuestion) {
          this.props.postUsersUpdatePassword({
            security_question: security_question,
            security_answer: security_answer,
          });
        }
      } else {
        this.props.postUsersUpdatePassword(user.id, {
          // 親アカウントから子アカウントのPW編集時は、現在のPWを入力しない
          password: password,
        });
      }
    }
  };

  handleKeyDown = (e) => {
    const enterKeyCode = 13;
    if (e.keyCode === enterKeyCode) {
      e.preventDefault();
      this.handleSubmit();
    }
  };

  validateForm = () => {
    const { showPassword, showSecurityQuestion, isChildEdit } = this.props;
    let { error } = this.state;
    let requestInfo = {};

    if (showPassword) {
      requestInfo["password"] = this.state.password;
      requestInfo["confirm_password"] = this.state.confirm_password;
      // 子アカウントのPW編集時は、現在のPWを入力しない
      if (!isChildEdit) {
        requestInfo["password_old"] = this.state.password_old;
      }
    }

    if (showSecurityQuestion) {
      requestInfo["security_question"] = this.state.security_question;
      requestInfo["security_answer"] = this.state.security_answer;
    }

    error = validateResetPassword(requestInfo, isChildEdit);

    this.setState({
      error: error,
    });

    return error;
  };

  validateItem = (property) => (event) => {
    let value = event.target.value;
    let err = {};

    if (property === "confirm_password") {
      err = validateResetPassword({
        password: this.state.password,
        [property]: value,
      });
    } else {
      err = validateResetPassword({
        [property]: value,
      });
    }

    let error = this.state.error;
    if (err.hasOwnProperty(property)) {
      error[property] = err[property];
    } else {
      delete error[property];
    }
    this.setState({
      error: error,
    });
  };

  hasBeenMoreThanAYearSinceLastPasswordReset = () => {
    const { user } = this.props;
    if (!!user && user.latest_password_reset_log !== null) {
      return moment().diff(
        moment(user.latest_password_reset_log.instruct_at),
        "years"
      ) >= 1;
    }

    return false;
  };

  render() {
    const { classes, user, showPassword, isChildEdit, showSecurityQuestion, buttonText } =
      this.props;
    const { error } = this.state;

    return (
      <form className={classes.form}>
        {showSecurityQuestion && (
          <div>
            <FormControl className={classes.formControl}>
              <FormLabel className={classes.formLabel}>
                セキュリティの質問
              </FormLabel>
              <Select
                classes={{ select: classes.select }}
                value={this.state.security_question}
                onChange={this.handleChange("security_question")}
                onKeyDown={this.handleKeyDown}
                disableUnderline={true}
                MenuProps={{
                  getContentAnchorEl: null,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                }}
              >
                {SECURITY_QUESTIONS.map((item) => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              id="security_answer"
              label="回答"
              type="text"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                disableUnderline: true,
              }}
              placeholder="回答を入力"
              onChange={this.handleChange("security_answer")}
              onBlur={this.validateItem("security_answer")}
              onKeyDown={this.handleKeyDown}
              error={error.hasOwnProperty("security_answer")}
              helperText={error.security_answer}
              margin="normal"
              fullWidth
            />
          </div>
        )}

        {showPassword && (
          <div>
            {!isChildEdit && (
              <div>
                <TextField
                  id="current_password"
                  label="現在のパスワード"
                  type="password"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                  placeholder="現在のパスワード"
                  onChange={this.handleChange("password_old")}
                  onBlur={this.validateItem("password_old")}
                  onKeyDown={this.handleKeyDown}
                  error={error.hasOwnProperty("password_old")}
                  helperText={error.password_old}
                  margin="normal"
                  fullWidth
                />
                {this.hasBeenMoreThanAYearSinceLastPasswordReset() && (
                  <Typography style={{ color: '#71737B' }}>現在のパスワードを忘れた場合は<Link to="/forget-password" className={classes.link}>こちら</Link></Typography>
                )}
              </div>
            )}

            <TextField
              id="password"
              label="新しいパスワード"
              type="password"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                disableUnderline: true,
              }}
              placeholder="新しいパスワードを入力"
              onChange={this.handleChange("password")}
              onBlur={this.validateItem("password")}
              onKeyDown={this.handleKeyDown}
              error={error.hasOwnProperty("password")}
              helperText={error.password}
              margin="normal"
              fullWidth
            />
            <TextField
              id="confirm-password"
              label="新しいパスワード（確認）"
              type="password"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                disableUnderline: true,
              }}
              placeholder="確認のためにもう一度新しいパスワードを入力"
              onChange={this.handleChange("confirm_password")}
              onBlur={this.validateItem("confirm_password")}
              onKeyDown={this.handleKeyDown}
              error={error.hasOwnProperty("confirm_password")}
              helperText={error.confirm_password}
              margin="normal"
              fullWidth
            />
          </div>
        )}
        <div className={classes.buttonContainer}>
          <Button
            color="primary"
            onClick={this.handleSubmit}
            onKeyDown={this.handleKeyDown}
            className={classes.button}
          >
            {buttonText}
          </Button>
        </div>
        {showPassword && !!user && !!user.latest_password_reset_log && (
          <Typography variant="body1" className={classes.lastUpdate}>
            パスワードの最終変更日：
            {moment(user.latest_password_reset_log.instruct_at).format(
              "YYYY-MM-DD HH:mm:ss"
            )}
          </Typography>
        )}
      </form>
    );
  }
}

ResetPasswordComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  postUsersUpdatePassword: PropTypes.func.isRequired,
  isChildEdit: PropTypes.bool,
  user: PropTypes.object,
  showPassword: PropTypes.bool,
  showSecurityQuestion: PropTypes.bool,
  addKeyDownListener: PropTypes.bool,
  buttonText: PropTypes.string,
  error: PropTypes.object,
};

ResetPasswordComponent.defaultProps = {
  showPassword: true,
  showSecurityQuestion: false,
  postUsersUpdatePassword: () => { },
};

PropTypes.defaultValue = {
  isChildEdit: false,
}

export default withStyles(styles)(ResetPasswordComponent);



// WEBPACK FOOTER //
// ./src/components/ResetPassword/ResetPasswordComponent.jsx